import {
    CLOSE_REFERRAL_MODAL,
    CloseReferralModalAction,
    OPEN_REFERRAL_MODAL,
    OpenReferralModalAction,
    TOGGLE_REFERRAL_MODAL,
    ToggleReferralModalAction,
} from './types';

export function toggleReferralModal(): ToggleReferralModalAction {
    return {
        type: TOGGLE_REFERRAL_MODAL,
    };
}

export function openReferralModal(): OpenReferralModalAction {
    return {
        type: OPEN_REFERRAL_MODAL,
    };
}

export function closeReferralModal(): CloseReferralModalAction {
    return {
        type: CLOSE_REFERRAL_MODAL,
    };
}
